import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { CustomFields } from './LciReportSetupForm';
import { Checkbox, FormControlLabel } from '@mui/material';

type IncludeSlideCheckboxProps = {
  name: FieldPath<CustomFields['includedSlides']>;
  label: string;
};

export const IncludeSlideCheckbox = ({
  name,
  label,
}: IncludeSlideCheckboxProps) => {
  const formContext = useFormContext<CustomFields>();
  return (
    <Controller
      control={formContext.control}
      name={`includedSlides.${name}`}
      render={({ field }) => {
        return (
          <FormControlLabel
            control={<Checkbox {...field} checked={!!field.value} />}
            label={label}
          />
        );
      }}
    />
  );
};
